export const integerInputPattern = /^\d*$/
export const decimalInputPattern = /^\d*(?:\.\d*)?$/
export const currencyInputPattern = /^\d*(?:\.\d{0,2})?$/

export const integerInputHtmlPattern = '[0-9]*'
export const decimalInputHtmlPattern = '[0-9]*[.]?[0-9]*'
